import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

export default function ProfileMatchBlock({ isPremium, onOpenPremiumModal, onOpenCompleteProfileModal, onOpenAnalysis }) {
  const { user } = useContext(AuthContext);
  const questionnaires = {
    valeurs: user.values_survey,
    interets: user.riasec_survey,
    energies: user.jourda_survey,
    intelligences: user.im_survey
  };
  const dimensionsUnlocked = Object.values(questionnaires).filter(Boolean).length;
  const allCompleted = dimensionsUnlocked === 4;

  const handleClick = () => {
    if (!isPremium) {
      onOpenPremiumModal();
    } else if (!allCompleted) {
      onOpenCompleteProfileModal();
    } else {
      onOpenAnalysis();
    }
  };

  return (
    <div
      onClick={handleClick}
      className="bg-slate-800 rounded-xl p-5 cursor-pointer border border-slate-700"
    >
      <div className="flex items-center justify-between mb-1">
        <h2 className="text-white font-semibold">Toi & ce métier</h2>
        <span className="text-gray-400 text-sm">{dimensionsUnlocked}/4</span>
      </div>
      <p className="text-gray-400 text-sm mb-4">
        {allCompleted
          ? "Ton profil est complet"
          : "Complète ton profil pour débloquer"}
      </p>

      {/* Dimensions en ligne avec couleurs */}
      <div className="flex gap-2 mb-4">
        {/* Valeurs - Violet */}
        <div className={`flex-1 rounded-lg py-3 px-2 ${questionnaires.valeurs ? 'bg-purple-900/40 border border-purple-700' : 'bg-slate-700 border border-slate-600'}`}>
          <div className="text-center">
            <span className={`text-xl ${questionnaires.valeurs ? '' : 'opacity-30'}`}>💎</span>
            <p className={`text-xs mt-1 ${questionnaires.valeurs ? 'text-purple-300' : 'text-gray-500'}`}>Valeurs</p>
          </div>
        </div>

        {/* Intérêts - Bleu */}
        <div className={`flex-1 rounded-lg py-3 px-2 ${questionnaires.interets ? 'bg-blue-900/40 border border-blue-700' : 'bg-slate-700 border border-slate-600'}`}>
          <div className="text-center">
            <span className={`text-xl ${questionnaires.interets ? '' : 'opacity-30'}`}>🧭</span>
            <p className={`text-xs mt-1 ${questionnaires.interets ? 'text-blue-300' : 'text-gray-500'}`}>Intérêts</p>
          </div>
        </div>

        {/* Énergies - Orange */}
        <div className={`flex-1 rounded-lg py-3 px-2 ${questionnaires.energies ? 'bg-orange-900/40 border border-orange-700' : 'bg-slate-700 border border-slate-600'}`}>
          <div className="text-center">
            <span className={`text-xl ${questionnaires.energies ? '' : 'opacity-30'}`}>⚡</span>
            <p className={`text-xs mt-1 ${questionnaires.energies ? 'text-orange-300' : 'text-gray-500'}`}>Énergies</p>
          </div>
        </div>

        {/* Intelligences - Vert */}
        <div className={`flex-1 rounded-lg py-3 px-2 ${questionnaires.intelligences ? 'bg-green-900/40 border border-green-700' : 'bg-slate-700 border border-slate-600'}`}>
          <div className="text-center">
            <span className={`text-xl ${questionnaires.intelligences ? '' : 'opacity-30'}`}>🧠</span>
            <p className={`text-xs mt-1 ${questionnaires.intelligences ? 'text-green-300' : 'text-gray-500'}`}>Intelligences</p>
          </div>
        </div>
      </div>

      {/* Encart selon le statut */}
      {isPremium && allCompleted ? (
        // Premium + 4 questionnaires : CTA vert
        <div className="p-3 rounded-lg bg-emerald-500/10 border border-emerald-500/30 text-center">
          <p className="text-emerald-400 text-sm font-medium">
            Voir mon analyse personnalisée →
          </p>
        </div>
      ) : isPremium ? (
        // Premium mais pas tous les questionnaires : encart neutre
        <div className="p-3 rounded-lg bg-slate-700/50 border border-slate-600">
          <div className="flex items-center gap-2">
            <span className="text-emerald-400">✨</span>
            <div className="flex-1">
              <p className="text-white text-sm font-medium">Analyse personnalisée</p>
              <p className="text-gray-500 text-xs">
                Complète ton profil pour découvrir si ce métier te correspond
              </p>
            </div>
            <span className="text-gray-500">→</span>
          </div>
        </div>
      ) : (
        // Freemium : encart Premium doré
        <div className="p-3 rounded-lg bg-amber-500/10 border border-dashed border-amber-500/30">
          <div className="flex items-center gap-2">
            <span className="text-amber-400">⭐</span>
            <div className="flex-1">
              <p className="text-amber-400 text-sm font-medium">Analyse personnalisée</p>
              <p className="text-gray-500 text-xs">
                Passe Premium pour découvrir si ce métier te correspond
              </p>
            </div>
            <span className="text-amber-500/50">→</span>
          </div>
        </div>
      )}
    </div>
  );
}
